import type { IncidentOpsState } from '../../services/incidentsApi';

export type FollowUpStatusOption = {
  value: IncidentOpsState;
  label: string;
};

/** Backend ops_state values with safety-manager follow-up labels (no schema change). */
export const FOLLOW_UP_STATUS_OPTIONS: FollowUpStatusOption[] = [
  { value: 'new', label: 'Not started' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'acknowledged', label: 'Blocked' },
  { value: 'resolved', label: 'Completed' },
  { value: 'closed', label: 'Closed' },
];

export const FOLLOW_UP_OWNER_FIELD_HELPER =
  'Person responsible for follow-up or corrective action.';

export const FOLLOW_UP_TEAM_FIELD_HELPER =
  'Team responsible for follow-up, such as Safety, Operations, Maintenance, or Facilities.';

export const FOLLOW_UP_STATUS_SECTION_TITLE = 'Follow-up status and next review';

export const FOLLOW_UP_STATUS_FIELD_LABEL = 'Follow-up status';

export const FOLLOW_UP_STATUS_SECTION_SUBTITLE =
  'Track whether corrective follow-up has started or finished. Action owner is assigned in Action ownership above.';

export const FOLLOW_UP_STATUS_SAVE_ALERT =
  'Follow-up status reflects execution progress only. Reviewer decisions stay in Evidence review.';

/**
 * Display label for ops_state as follow-up execution status.
 * `acknowledged` means Blocked when set explicitly; when paired with ACKED workflow it is the ack handoff (In progress).
 */
export function formatFollowUpStatusDisplayLabel(
  opsState: string | null | undefined,
  workflowStatus?: string | null,
): string {
  const state = String(opsState || 'new').trim().toLowerCase() as IncidentOpsState;
  if (state === 'acknowledged') {
    const workflow = String(workflowStatus || '').trim().toUpperCase();
    if (workflow === 'ACKED') {
      return 'In progress';
    }
    return 'Blocked';
  }
  const match = FOLLOW_UP_STATUS_OPTIONS.find((option) => option.value === state);
  return match?.label || 'Not started';
}
